module.exports = __webpack_public_path__ + "static/media/noResultsCompany.19c15255.png";